/**
 * 编辑视图模块路由（优化版）
 */
export default [
  {
    path: "/menu",
    component: resolve => require(["@/views/menu.vue"], resolve),
    redirect: "/menu/home",
    children: [
      {
        path: "clue",  // 使用相对路径
        component: resolve => require(["@/modules/clue/pages/index.vue"], resolve),
        redirect: "/menu/clue/cluelist",
        children: [
          {
            path: "cluelist",  
            component: resolve => require(["@/modules/clue/pages/clueList/ClueList.vue"], resolve)
          },
          {
            path: "cluelist/cluedetail/:id",  
            name: "cluedetail",
            component: resolve => require(["@/modules/clue/pages/clueList/ClueDetail.vue"], resolve)
          },
          {
            path: "cluereceive/seting",  
            component: resolve => require(["@/modules/clue/pages/clueReceive/ClueReceive.vue"], resolve)
          },
          {
            path: "cluereceive/seting/organization", 
            component: resolve => require(["@/modules/clue/pages/clueReceive/organization.vue"], resolve)
          },
          {
            path: "cluereceive/seting/channelSetting", 
            component: resolve => require(["@/modules/clue/pages/clueReceive/ChannelSetting.vue"], resolve)
          },
          {
            path: "cluereceive/seting/ccOrganization",  
            component: resolve => require(["@/modules/clue/pages/clueReceive/CcOrganization.vue"], resolve)
          },
          {
            path: "cluereceive/seting/customRules",  
            component: resolve => require(["@/modules/clue/pages/clueReceive/CustomRules.vue"], resolve)
          },
          {
            path: "cluereceive/syncRules", 
            component: resolve => require(["@/modules/clue/pages/clueReceive/SyncRules.vue"], resolve)
          },
          {
            path: "cluereceive/noRepeat",  
            component: resolve => require(["@/modules/clue/pages/clueReceive/CluenoRepeat.vue"], resolve)
          },
          {
            path: "cluesetting",  
            component: resolve => require(["@/modules/clue/pages/clueSetting/ClueSetting.vue"], resolve)
          }
        ]
      }
    ]
  }
];
